import axios from 'axios'
import {Message} from 'element-ui'
axios.defaults.timeout = 10000
axios.defaults.headers.post['Content-Type'] = 'application/x-www=form-urlencoded'
// axios.defaults.baseURL = 'http://www.jinhaique.cn'
export default {
  fetchGet(url, params = {}) {
    return new Promise((resolve, reject) => {
      console.log("url",url);
      axios.get(url, params).then(res => {
        console.log("res",res);
        if (res.data.code != 200) {
          Message({
            message: "接口服务异常",
            type: 'error'
          })
        } else {
          resolve(res.data)
        }
      }).catch(error => {
        console.log('err' + error)
        let { message } = error;
        if (message == "Network Error") {
          message = "后端接口连接异常";
        }
        else if (message.includes("timeout")) {
          message = "系统接口请求超时";
        }
        else if (message.includes("Request failed with status code")) {
          message = "系统接口" + message.substr(message.length - 3) + "异常";
        }
        Message({
          message: message,
          type: 'error',
          duration: 5 * 1000
        })
        reject(error)
      })
    })
  },
  fetchPost(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.post(url, params).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/public.js